// 9fbef606107a605d69c0edbcd8029e5d
import { PropTypes } from 'prop-types';
import React from 'react';
import { getImageFilePath } from '@tcp/core/src/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getStoreFilterData } from '@tcp/core/src/components/features/browse/ShopThisStore/container/ShopThisStore.utils';
import { SHOP_THIS_STORE_SCROLL } from '../../../../../constants/shopThisStore.constant';
import { removeSessionStorage, routerPush } from '../../../../../utils';
import withStyles from '../../../hoc/withStyles';
import Button from '../../Button';
import style from '../styles/ShopThisStoreCta.style';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import {
  lblStoredetailsShopThisStore,
  STORE_DETAILS_LABELS,
  StoreLocatorLabels,
} from '../../../../features/storeLocator/Labels/StoreLocator.labels';

const handleStsClick = (updateStore, store, basicInfo, trackAnalyticsClick) => {
  trackAnalyticsClick({
    eventCategory: 'store',
    eventAction: 'shop this store: store locator',
    pageNavigationText: basicInfo?.storeName,
  });
  updateStore(store);
  removeSessionStorage(SHOP_THIS_STORE_SCROLL);
  routerPush(
    `/search?search/shop-this-store?searchQuery=*&bopisStoreId=${encodeURIComponent(
      getStoreFilterData(store)
    )}&sort=${encodeURIComponent('newest_score desc')}`,
    `/search/shop-this-store?bopisStoreId=${encodeURIComponent(
      getStoreFilterData(store)
    )}&sort=${encodeURIComponent('newest_score desc')}`
  );
};

const ShopThisStoreCta = ({
  className,
  basicInfo,
  updateStore,
  store,
  trackAnalyticsClick,
  classForMargin,
  fromStoreDetailPage,
}) => {
  const shopThisStoreCtaLabel = getLabelFromCopyOrFromTranslation(
    `${STORE_DETAILS_LABELS}.${lblStoredetailsShopThisStore}`,
    StoreLocatorLabels
  );
  return (
    <Button
      className={`${className} ${classForMargin} sth-main`}
      onClick={() => {
        handleStsClick(updateStore, store, basicInfo, trackAnalyticsClick);
      }}
    >
      <div className="icon-label-container">
        {!fromStoreDetailPage && (
          <Image
            className="shop-this-store-new-icon"
            height="12px"
            src={`${getImageFilePath()}/store-icon-new.svg`}
          />
        )}
        {shopThisStoreCtaLabel}
      </div>
    </Button>
  );
};

ShopThisStoreCta.propTypes = {
  className: PropTypes.string.isRequired,
  basicInfo: PropTypes.shape({}),
  fromStoreDetailPage: PropTypes.bool,
};
ShopThisStoreCta.defaultProps = {
  basicInfo: {},
  fromStoreDetailPage: false,
};

export default withStyles(ShopThisStoreCta, style);
export { ShopThisStoreCta as ShopThisStoreCtaVanilla };
